module.exports = __webpack_public_path__ + "img/MixerTruck.23dd1d2a.png";